/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Canvas_Page_BreakInputs */

const cs_builder_canvas_page_break = /** @type {(inputs: Builder_Canvas_Page_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konec stránky`)
};

const en_builder_canvas_page_break = /** @type {(inputs: Builder_Canvas_Page_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page break`)
};

/**
* | output |
* | --- |
* | "Page break" |
*
* @param {Builder_Canvas_Page_BreakInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_canvas_page_break = /** @type {((inputs?: Builder_Canvas_Page_BreakInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Canvas_Page_BreakInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_canvas_page_break(inputs)
	return cs_builder_canvas_page_break(inputs)
});